import React from 'react';
import { Card, CardContent } from './ui/card';
import { Zap, Shield, Headphones, TrendingUp, Award, Clock } from 'lucide-react';

const ICON_MAP = {
  Award, Shield, Headphones, TrendingUp, Zap, Clock
};

const GRADIENTS = [
  'from-blue-500 to-blue-600',
  'from-blue-600 to-blue-700',
  'from-yellow-500 to-yellow-600',
  'from-blue-700 to-blue-800',
  'from-yellow-600 to-yellow-700',
  'from-blue-500 to-blue-700'
];

const WhyChooseUs = ({ reasons = [] }) => {
  if (!reasons || reasons.length === 0) return null;

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-3">Why Choose Us</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Your Partner For <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800">Success</span>
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-500 to-yellow-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const IconComponent = ICON_MAP[reason.icon] || Award;
            const gradient = GRADIENTS[index % GRADIENTS.length];
            return (
              <Card key={index} className="border-2 hover:border-blue-200 transition-all hover:shadow-xl group">
                <CardContent className="p-8">
                  <div className={`w-16 h-16 bg-gradient-to-br ${gradient} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                    <IconComponent className="text-white" size={32} />
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h4>
                  <p className="text-gray-600 leading-relaxed">{reason.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
